export class UsuarioModel {
    email: string;
    password: string;
}